export const content = {
  'designer.interactions.tab.tooltip.enabled': 'Interactions (H)',
};
